import { useState } from 'react';
import { AppContainer, Content, Logo, getGlobalStyles } from './Styles';
import { GlobalStyles } from '@mui/material';
import products from './config/products';
import { getProduct, getSearchParams } from './utils';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { Notification, FreshChat, Form, Contacts } from './components';

const App = () => {
  const [widget, setWidget] = useState();
  const searchParams = getSearchParams();
  const product = getProduct();
  const theme = useTheme();

  const productConfig = products[product];
  const { background, logo, maxWidth, freshchat, whatsapp, iMessage } = productConfig;
  const isContact = freshchat || whatsapp || iMessage;

  const globalStyles = getGlobalStyles(background);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={globalStyles} />
      <Notification />
      <FreshChat token={freshchat} setWidget={setWidget} searchParams={searchParams} />
      <AppContainer>
        <Logo src={logo} maxWidth={maxWidth} isContact={isContact} />
        <Content>
          {isContact && (
            <Contacts productConfig={productConfig} widget={widget} searchParams={searchParams} />
          )}
          <Form searchParams={searchParams} />
        </Content>
      </AppContainer>
    </ThemeProvider>
  );
};

export default App;
